import axios from "axios";

const baseDomain = process.env.VUE_APP_API_BASE_URL_GENERAL;

const baseURL = `${baseDomain}`;

const token = localStorage.getItem("token");

const AxiosInstance = axios.create({
  baseURL,
  headers: {
    common: {
      Token: token ? token : null
    }
  }
});

export default AxiosInstance;
